export function contactCreateBody(values: Record<string, string>): { number:string; name:string } {
  return { number:values.waId ?? '', name:values.displayName ?? values.profileName ?? '' };
}

/** Mantém a tabela renderizável durante trocas de rota e diante de respostas
 * antigas da API que ainda não incluíam a lista de etiquetas. */
export function contactTags<T>(tags: T[] | undefined): T[] {
  return tags ?? [];
}
